<template>
  <div :class="[
    'v-sidebar_item',
    {
      'v-sidebar_item--active': active
    }
  ]">
    <a v-bind="{ href, target, title }"><slot name="default"></slot></a>
    <div v-if="hasItems && active" class="v-sidebar_item__items">
      <slot name="items"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  },
  computed: {
    hasItems() {
      return !!this.$slots.items || !!this.$scopedSlots.items;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-sidebar_item {
  a {
    display: block;
    color: inherit;
    text-decoration: none;
    padding: $spacer * 0.5 0;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      color: theme-color("primary");
      text-decoration: none;
    }

    &:active {
      color: theme-color("primary");
    }
  }

  &:first-child {
    a {
      padding-top: 0;
    }
  }

  &--active {
    color: theme-color("primary");

    a {
      font-weight: bold;
    }
  }

  &__items {
    color: theme-color("gray-dark");
    border-left: 1px solid #ccc;
    margin: $spacer * 0.5 0;

    .v-sidebar_item:first-child {
      a {
        padding-top: $spacer * 0.5;
      }
    }

    .v-sidebar_item--active & {
      a {
        padding-left: $spacer;
        font-weight: normal;
      }
    }

    .v-sidebar_item--active a {
      font-weight: bold;
    }
  }
}
</style>
